var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "actions-editor" }, [
    _vm.localActions.length === 0
      ? _c(
          "div",
          { staticClass: "empty-actions" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("contactModuleRules.actionsEditor.noActions"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.addAction } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("contactModuleRules.actionsEditor.addFirstAction")
                    ) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "draggable",
              {
                staticClass: "actions-list",
                attrs: { handle: ".action-drag-handle" },
                model: {
                  value: _vm.localActions,
                  callback: function ($$v) {
                    _vm.localActions = $$v
                  },
                  expression: "localActions",
                },
              },
              _vm._l(_vm.localActions, function (action, index) {
                return _c(
                  "div",
                  { key: "action-" + index, staticClass: "action-card" },
                  [
                    _c(
                      "div",
                      { staticClass: "action-header" },
                      [
                        _c(
                          "i",
                          { staticClass: "material-icons action-drag-handle" },
                          [_vm._v("drag_indicator")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "action-number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.actionsEditor.actionNumber",
                                { n: index + 1 }
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "spacer" }),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "text", size: "small", danger: "" },
                            on: {
                              click: function ($event) {
                                return _vm.removeAction(index)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("delete"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "action-body" }, [
                      _c(
                        "div",
                        { staticClass: "action-type-selector" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "contactModuleRules.actionsEditor.actionType"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              on: {
                                change: function () {
                                  return _vm.onActionTypeChange(action)
                                },
                              },
                              model: {
                                value: action.type,
                                callback: function ($$v) {
                                  _vm.$set(action, "type", $$v)
                                },
                                expression: "action.type",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "none" } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("block"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("contactModuleRules.doNothing")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "change-owner" } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("assignment_ind"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("contactModuleRules.changeOwner")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "add-tag" } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("label"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("contactModuleRules.addTag")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "add-department" } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("business"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "contactModuleRules.addDepartment"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "upsert-contact-property" } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit_note"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "contactModuleRules.updateProperty"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      action.type !== "none"
                        ? _c(
                            "div",
                            { staticClass: "action-config" },
                            [
                              action.type === "change-owner"
                                ? _c("ChangeOwnerConfig", {
                                    on: { input: _vm.emitChange },
                                    model: {
                                      value: action.changeOwner,
                                      callback: function ($$v) {
                                        _vm.$set(action, "changeOwner", $$v)
                                      },
                                      expression: "action.changeOwner",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              action.type === "add-tag"
                                ? _c("AddTagConfig", {
                                    on: { input: _vm.emitChange },
                                    model: {
                                      value: action.addTag,
                                      callback: function ($$v) {
                                        _vm.$set(action, "addTag", $$v)
                                      },
                                      expression: "action.addTag",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              action.type === "add-department"
                                ? _c("AddDepartmentConfig", {
                                    attrs: { "when-type": _vm.whenType },
                                    on: { input: _vm.emitChange },
                                    model: {
                                      value: action.addDepartment,
                                      callback: function ($$v) {
                                        _vm.$set(action, "addDepartment", $$v)
                                      },
                                      expression: "action.addDepartment",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              action.type === "upsert-contact-property"
                                ? _c("UpsertContactPropertyConfig", {
                                    on: { input: _vm.emitChange },
                                    model: {
                                      value: action.upsertContactProperty,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          action,
                                          "upsertContactProperty",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "action.upsertContactProperty",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-action-btn", on: { click: _vm.addAction } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("contactModuleRules.actionsEditor.addAction"))
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("playlist_add")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }